import { InsuranceDataStateService } from './../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Offer } from '../../../core/models/offer/offer.model';
import { LanguageService } from '../../services/language.service';
import { OfferBasicItemComponent } from '../offer-basic-item/offer-basic-item.component';
import { AgreementsStateService } from '../../../core/services/impl/section-services/agreements/agreements-state.service';
import { MatDialog } from '@angular/material';
import { MetricsDataModel } from '../models/metrics/metrics-data.model';
import { CustomMetricsName } from '../models/metrics/custom-metrics-name.enum';
import { MetricsType } from '../models/metrics/metrics-type.enum';
import { OfferMetricDataModel } from '../models/metrics/offer-metric-data.model';
import { OfferService } from '../../../core/services/impl/offer.service';
import { MetricsService } from '../../services/metrics.service';
import { VehicleDataModel } from '../../../core/models/vehicle-data.model';
import { VehicleModelState } from '../../states/vehicle-model.state';
import { RegistrationService } from '../../../core/services/impl/registration.service';
import { StepKey } from '../../../core/enums/step-key.enum';
import { NavigateManagerService } from '../../../core/services/navigate-manager.service';
import { OfferSectionStateService } from '../../../core/services/impl/section-services/offers/offer-section-state.service';
import { ApplicationStateService } from '../../services/application-state.service';
import { AppMode } from '../../models/app-mode.enum';
import {VehicleModelStateService} from '../../../core/services/impl/section-services/vehicle-model/vehicle-model-state.service';
import {OfferModificationsService} from '../../../core/services/impl/offer-modifications/offer-modifications.service';
import {addDaysToDate, changeDateByYears, isKIOSKPOLIS, isYANOSIK, isNext} from '../../../core/utils/utils';
import {OfferResourceService} from '../../../core/services/impl/offer-resource.service';
import {OffersPresentationMode} from '../../../core/services/impl/offers-presentation.service';
import {DetailCoverageGroupBox, OfferCoveragesService} from '../../../core/services/impl/offer-coverages.service';
import {OffersComparisonDialogComponent} from '../dialogs/offers-comparison-dialog/offers-comparison-dialog.component';
import {
  OffersPresentationComponent
} from '../../sections/web/offer-section/offers-presentation/offers-presentation.component';

@Component({
  selector: 'app-offer-selected-item',
  templateUrl: './offer-selected-item.component.html',
  styleUrls: ['./offer-selected-item.component.scss']
})
export class OfferSelectedItemComponent extends OfferBasicItemComponent implements OnInit, OnDestroy {

  offer: Offer;
  ownerInfo: string;
  startDate: Date;
  endDate: Date = new Date();
  offerDetailsMetric: MetricsDataModel;
  sectionVisible = true;
  selectedOfferBoxFullWidth = false;
  detailCoverageGroupBoxes: DetailCoverageGroupBox[];
  isNext = isNext();

  get offerDetailsBtnIcon(): string {
    return isYANOSIK() ? 'arrow_forward' : 'arrow_right';
  }

  get metricValue(): OfferMetricDataModel {
    return {
      offerId: this.offer.id,
      calculationId: this.offerService.calculationId,
      processId: this.offerService.processId
    };
  }

  get vehicleData(): VehicleDataModel {
    return this.stateService.vehicleData;
  }

  get vehicleModelState(): VehicleModelState {
    return this.stateService.vehicleModelState;
  }

  get hasModifications(): boolean {
    return this.offerModificationsService.offerModificationsEnabled && this.offer.modifications && this.offer.modifications.length > 0;
  }

  get selectedPremium(): string {
    return this.registrationService.premiumId;
  }

  constructor(resourceService: OfferResourceService,
              language: LanguageService,
              public vehicleModelStateService: VehicleModelStateService,
              public offerModificationsService: OfferModificationsService,
              private stateService: AgreementsStateService,
              private insuranceDataStateService: InsuranceDataStateService,
              private dialog: MatDialog,
              private metricsService: MetricsService,
              private offerService: OfferService,
              private offerCoveragesService: OfferCoveragesService,
              private offerSectionStateService: OfferSectionStateService,
              private navigateManager: NavigateManagerService,
              private appStateService: ApplicationStateService,
              private registrationService: RegistrationService) {
    super(resourceService, language);
  }

  ngOnInit() {
    this.initComponent();

    const subscription = this.offerService.getOfferEvent.subscribe(event => {
      subscription.unsubscribe();
      this.sectionVisible = false;
      this.initComponent();
      setTimeout(() => {
        this.sectionVisible = true;
      });
    });
  }

  public ngOnDestroy(): void {
    // this.offerService.resetSelectedOffer();
  }

  public openOffersPresentation() {
    this.openMetric();
    const dialogComponent: any = this.isNext ? OffersComparisonDialogComponent : OffersPresentationComponent;
    this.dialog.open(dialogComponent,
        dialogComponent.getConfigBuilder().buildConfiguration({
        offers: [this.offer],
        mode: OffersPresentationMode.OFFER_DETAILS,
        selectOfferEvent: null
      })).afterClosed().subscribe(() => {
      this.closeMetric();
    });
  }

  public backToOffers(): void {
    this.appStateService.mode = AppMode.RAW;
    this.offerService.sendCalculation().then(() => this.navigateManager.moveToStep(StepKey.SECOND_STEP));
  }

  public get canShowChangePackageButton(): boolean {
    return false;
  }

  protected createBoxes({coverages}: Offer) {
    super.createBoxes(this.offer);
    if (this.isNext) {
      this.detailCoverageGroupBoxes = this.offerCoveragesService.createDetailCoverageGroupBoxes(this.offer);
    }
  }

  private initComponent(): void {
    this.stateService.init();
    this.offer = this.stateService.selectedOffer;
    this.setOwnerInfo();
    this.setLogo(this.offer);
    this.setInsurancePeriodInfo();
    this.createBoxes(this.offer);
    this.setSelectedOfferBoxFullWidth();
    this.setAmount(this.offer);
    this.handleModifiedOfferEvent();

    this.registrationService.offerId = this.offer.id;
  }

  private setOwnerInfo(): void {
    const ownerData = this.stateService.ownerData;
    this.ownerInfo = `${ownerData.firstName} ${ownerData.lastName}`;
  }

  private setInsurancePeriodInfo(): void {
    this.startDate = this.insuranceDataStateService.insuranceData.startInsuranceDate;
    this.endDate = addDaysToDate(changeDateByYears(new Date(this.startDate), 1), -1);
  }

  private rebuildSection(): void {
    this.offer = this.stateService.selectedOffer;
    this.createBoxes(this.offer);
    this.setAmount(this.offer);
  }

  private handleModifiedOfferEvent(): void {
    this.offerModificationsService.modifiedOfferEvent.subscribe(() => {
      this.sectionVisible = false;
      this.rebuildSection();
      this.sectionVisible = true;
    });
  }

  private setSelectedOfferBoxFullWidth() {
    const visiblePrimaryBoxes = this.primaryBoxes.filter(primaryBox => this.canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled));
    this.selectedOfferBoxFullWidth = visiblePrimaryBoxes && visiblePrimaryBoxes.length === 4;
  }

  private openMetric(): void {
    this.offerDetailsMetric = new MetricsDataModel(CustomMetricsName.OFFER_DETAILS, MetricsType.COMPONENT);
    this.offerDetailsMetric.open();
    this.offerDetailsMetric.value = JSON.stringify(this.metricValue);
  }

  private closeMetric(): void {
    this.offerDetailsMetric.close();
    this.metricsService.send(this.offerDetailsMetric);
  }
}
